


















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class BookmarkIcon extends Vue {
  @Prop({ default: '24' }) readonly width?: string;
  @Prop({ default: '24' }) readonly height?: string;
  @Prop({ default: '#405F7A' }) readonly color?: string;
}
